'use client';

import { useState } from 'react';
import { BoxIcon } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from '@/components/ui/tooltip';
import { SuggestionBoxDialog } from './suggestion-box-dialog';
import { cn } from '@/lib/utils';

export function SuggestionBoxButton({
  compact = false
}: {
  compact?: boolean;
}) {
  const [open, setOpen] = useState(false);

  const button = (
    <Button
      variant="outline"
      size={compact ? 'icon' : 'default'}
      className={cn(
        'hover:bg-accent hover:text-accent-foreground gap-2',
        compact ? 'h-8 w-8' : 'w-full justify-center px-3 text-sm font-normal'
      )}
      onClick={() => setOpen(true)}
    >
      <BoxIcon className="h-4 w-4" />
      {!compact && 'Suggestion Box'}
    </Button>
  );

  return (
    <>
      {compact ? (
        <Tooltip>
          <TooltipTrigger asChild>{button}</TooltipTrigger>
          <TooltipContent side="right">Suggestion Box</TooltipContent>
        </Tooltip>
      ) : (
        button
      )}

      <SuggestionBoxDialog open={open} onOpenChange={setOpen} />
    </>
  );
}
